require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./soluciones-tecnicas-decoracion-pinturas.json") })
        }
      }, "path---soluciones-tecnicas-decoracion-pinturas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---soluciones-tecnicas-decoracion-pinturas!./.cache/json/soluciones-tecnicas-decoracion-pinturas.json
// module id = 288
// module chunks = 231608221292675